export interface INavListItem {
	path: string;
	label: string;
	icon: string;
	activeIcon: string;
}
